export default "__VITE_ASSET__D40KRwGY__"